/**
 * PostHog product analytics.
 *
 * The first statement is PostHog's stub loader, verbatim: it queues calls on
 * `window.posthog` and fetches the real client asynchronously from
 * `api_host` (our reverse proxy, which serves `/static/array.js`). `init`
 * then configures the project.
 */
!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
// This cookie contains opaque IDs only. Shopify's sandbox reads it through
// browser.cookie; it never initializes a second PostHog browser SDK.
(() => {
  const bridgeCookie = 'tiiga_posthog_bridge';
  let initialized = false;
  let client;
  let allowed = false;

  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clearBridge = () => {
    document.cookie = `${bridgeCookie}=; Path=/; Max-Age=0; SameSite=Lax; Secure`;
  };
  const syncBridge = () => {
    if (!client || !allowed || !analyticsAllowed()) return;
    const bridge = {
      distinct_id: client.get_distinct_id(),
      session_id: client.get_session_id(),
      updated_at: Date.now(),
    };
    document.cookie = `${bridgeCookie}=${encodeURIComponent(JSON.stringify(bridge))}; Path=/; Max-Age=1800; SameSite=Lax; Secure`;
  };

  const syncConsent = () => {
    const next = analyticsAllowed();
    if (!next) {
      if (client && allowed) client.opt_out_capturing();
      allowed = false;
      clearBridge();
      return;
    }
    if (allowed) return;
    allowed = true;
    if (!initialized) {
      initialized = true;
      window.posthog.init('phc_zWMHMETCKPmTmGovrKb2MN9KAmz5gEnVgAPzUhUQkiFk', {
        // Managed reverse proxy: requests (and the SDK download) go through our
        // own domain, so ad blockers that block posthog.com don't drop events
        api_host: 'https://g.workmanusa.com',
        // Links PostHog builds (the toolbar, replay URLs) point at the app, not the proxy
        ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30',
        capture_pageview: false,
        person_profiles: 'identified_only',
        session_recording: { maskAllInputs: true },
        loaded: (sdk) => {
          client = sdk;
          // Consent may have changed while the SDK was downloading.
          if (!analyticsAllowed()) {
            sdk.opt_out_capturing();
            allowed = false;
            clearBridge();
            return;
          }
          if (sdk.has_opted_out_capturing()) sdk.opt_in_capturing();
          sdk.capture('$pageview');
          sdk.onSessionId(syncBridge);
          syncBridge();
        },
      });
    } else if (client) {
      client.opt_in_capturing();
      client.capture('$pageview');
      syncBridge();
    }
  };

  // Contact is attached to the existing visitor, preserving its earlier events
  // and recordings. A submitted address is not proof of account ownership.
  const contactSubmitted = (detail) => {
    if (!client || !allowed || !analyticsAllowed()) return;
    const properties = {};
    if (typeof detail.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(detail.email.trim())) {
      properties.email = detail.email.trim().toLowerCase();
    }
    if (typeof detail.phone === 'string' && /^\+[1-9]\d{6,14}$/.test(detail.phone)) properties.phone = detail.phone;
    if (!Object.keys(properties).length) return;
    client.setPersonProperties(properties);
    client.capture('contact_info_submitted', { source: detail.source || 'signup_popup', channel: detail.channel });
    syncBridge();
  };
  document.addEventListener('signup-popup:subscribed', (event) => contactSubmitted(event.detail || {}));
  document.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail;
    if (detail?.type !== 'submit') return;
    contactSubmitted({ email: detail.metaData?.$email, phone: detail.metaData?.$phone_number, source: 'klaviyo_form' });
  });
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', syncBridge, { capture: true, passive: true });
  document.addEventListener('submit', syncBridge, { capture: true, passive: true });
  window.addEventListener('pageshow', syncBridge);

  const start = () => {
    if (window.Shopify?.designMode) return;
    if (window.Shopify?.customerPrivacy) syncConsent();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncConsent();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
